import { type ListenerFn } from 'eventemitter2';
import { events } from '@middleware/events';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class EventDispatcher {
  static sendEvent<T>(type: string, objParams?: T): void {
    events.emit(type, objParams);
  }

  static on(type: string, listener: ListenerFn): void {
    events.on(type, listener);
  }

  static once(type: string, listener: ListenerFn): void {
    events.once(type, listener);
  }

  static off(type: string, listener: ListenerFn): void {
    events.off(type, listener);
  }

  static removeListener(type: string, listener: ListenerFn): void {
    events.removeListener(type, listener);
  }
}
